@if(isInProgreess()){

<div class="h-100 d-flex flex-column justify-content-center align-items-center">
  <div class="d-flex flex-column justify-content-center progress-card ">

    <h2 class="mt-0">
      {{ "Aguarde enquanto geramos o documento" | translate}}
    </h2>

      <h3 class="m-0 d-flex flex-row small-gap  align-items-center">
      @if(isInPending()){
        {{'Preparando documento' | translate}}
      }@else {

        {{"Buscando dados" | translate}}

        @if(progressPercentage() <= 33){ <div class="text m-0" [@rollInOut] >
          {{ 'do estagiário' | translate}}
          </div>
          } @else {

          @if( progressPercentage()> 33 && progressPercentage() <= 66){ <div class="text m-0" [@rollInOut]>
            {{ "da concedente" | translate}} </div>

            }@else {
            <div class="text m-0" [@rollInOut] >
              {{ "da instituição" | translate}} </div>
            }

            }
    }

      <cnet-progress-dots size="4" color="secondary" />
    </h3>

    <cnet-progress-bar color="secondary" [value]="progressPercentage()" />
  </div>
</div>

}
@else {
<app-iframe-handler [src]="url().url" [@fadeInOut] />
}
